<h2 mat-dialog-title>Stripe Payments</h2>

<mat-dialog-content class="stripe-payments-dialog">
  <div class="user-summary">
    <div>
      <div class="user-name">{{data.user.firstName}} {{data.user.lastName}}</div>
      <div class="user-email">{{data.user.email}}</div>
    </div>
    @if (customerId) {
      <div class="customer-id">{{customerId}}</div>
    }
  </div>

  @if (!loading && invoices.length === 0) {
    <div class="empty">No Stripe payments found for this user.</div>
  }

  @if (invoices.length > 0) {
    <div class="payments-table-wrap">
      <table mat-table [dataSource]="invoices" class="payments-table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let invoice">{{invoice.date | date:'medium'}}</td>
        </ng-container>
        <ng-container matColumnDef="info">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let invoice">
            <button mat-button class="invoice-link" (click)="openInvoice(invoice)">{{invoice.info}}</button>
          </td>
        </ng-container>
        <ng-container matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef>Payment Method</th>
          <td mat-cell *matCellDef="let invoice">{{invoice.details?.paymentType || '-'}}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let invoice">{{invoice.amount | currency}}</td>
        </ng-container>
        <ng-container matColumnDef="refunded">
          <th mat-header-cell *matHeaderCellDef>Refunded</th>
          <td mat-cell *matCellDef="let invoice">{{(invoice.amountRefunded || 0) | currency}}</td>
        </ng-container>
        <ng-container matColumnDef="remaining">
          <th mat-header-cell *matHeaderCellDef>Refundable</th>
          <td mat-cell *matCellDef="let invoice">{{(invoice.refundableAmount || 0) | currency}}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let invoice">{{invoice.status}}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let invoice">
            @if (isRefunded(invoice)) {
              <button
                mat-stroked-button
                color="primary"
                (click)="openRefundDetails(invoice)"
                >
                Details
              </button>
            } @else {
              <button mat-stroked-button color="primary" [disabled]="!canRefund(invoice)" (click)="selectRefund(invoice)">
                Refund
              </button>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
